import React, { useEffect, useState } from "react";
import { Switch, Spin, message } from "antd";
import "./style.scss";
import { fetchApplications, fetchPartnerAppAccess } from "../../services/get";
import { updatePartnerAppAccess } from "../../services/put";

// Franchise/B2B partner <-> application access (technical design doc §2) —
// NOT franchise-only, any Franchise or B2B partner can be granted access.
const ApplicationAccess = ({ partnerId }) => {
  const [applications, setApplications] = useState([]);
  const [access, setAccess] = useState([]);
  const [loading, setLoading] = useState(false);
  const [savingId, setSavingId] = useState(null);

  useEffect(() => {
    if (partnerId) loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partnerId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const [apps, partnerAccess] = await Promise.all([
        fetchApplications(),
        fetchPartnerAppAccess(partnerId),
      ]);
      setApplications(apps || []);
      setAccess(partnerAccess || []);
    } catch (error) {
      message.error("Failed to load application access");
    } finally {
      setLoading(false);
    }
  };

  const isActiveFor = (applicationId) =>
    access.find((a) => a.applicationId === applicationId)?.isActive || false;

  const handleToggle = async (applicationId, checked) => {
    setSavingId(applicationId);
    try {
      await updatePartnerAppAccess(partnerId, applicationId, checked);
      message.success(checked ? "Access granted" : "Access revoked");
      await loadData();
    } catch (error) {
      message.error(
        error?.response?.data?.message || error?.message || "Failed to update access"
      );
    } finally {
      setSavingId(null);
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="application-access">
        {applications.length === 0 && !loading && (
          <div className="empty-state">No applications in the catalog yet.</div>
        )}
        {applications.map((app) => (
          <div className="application-access-row" key={app.id}>
            <div className="app-info">
              <div className="app-name">{app.name}</div>
              <div className="app-code">{app.code}</div>
            </div>
            <Switch
              checked={isActiveFor(app.id)}
              loading={savingId === app.id}
              onChange={(checked) => handleToggle(app.id, checked)}
            />
          </div>
        ))}
      </div>
    </Spin>
  );
};

export default ApplicationAccess;
